// Shared namespace and site configuration. Loaded before every other app script.
window.el = window.el || {};

window.el.CONFIG = {
  // Browser key for the contact page map; restrict it by HTTP referrer in the Google Cloud console.
  googleMapsApiKey: "AIzaSyDxNiYCXEohKb6S5brSn3P2EpW48mwKr9Y",
};
